var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _vm.showToastLogo
      ? _c(
          "em",
          { staticClass: "logo" },
          [
            _c(
              "router-link-ex",
              {
                staticClass: "link_txt",
                attrs: {
                  to: _vm.countryPath,
                  domain: _vm.getDomain("homepage")
                }
              },
              [
                _c("img", {
                  staticClass: "logo_img is_white",
                  attrs: {
                    src: _vm.imagePath(
                      _vm.toastLogo.white,
                      _vm.toastLogo.default
                    ),
                    alt: "NHN Cloud"
                  }
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "logo_img is_color",
                  attrs: {
                    src: _vm.imagePath(
                      _vm.toastLogo.color,
                      _vm.toastLogo.default
                    ),
                    alt: "NHN Cloud"
                  }
                })
              ]
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "h1",
      { staticClass: "logo service_logo" },
      [
        _c(
          "router-link-ex",
          {
            staticClass: "link_txt",
            attrs: {
              to: _vm.isDefaultSetting ? _vm.countryPath : "/",
              domain: _vm.isDefaultSetting ? _vm.getDomain("homepage") : ""
            }
          },
          [
            _c("img", {
              staticClass: "logo_img is_white",
              attrs: {
                src: _vm.imagePath(_vm.logo.white, _vm.logo.default),
                alt: "NHN Cloud"
              }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "logo_img is_color",
              attrs: {
                src: _vm.imagePath(_vm.logo.color, _vm.logo.default),
                alt: "NHN Cloud"
              }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "logo_img_m",
              class: _vm.envs.logo.class,
              attrs: {
                src: _vm.imagePath(_vm.logo.mobile, _vm.logo.default),
                alt: "NHN Cloud"
              }
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }